import { useQueryDetails } from '@gogame/query';

import { loadComments } from 'scenes/Gallery/GalleryPage/Concepts/Comments/sources/comments';

import { list } from './queryKeyFactory';

export const useComments = (conceptId) => {
  return useQueryDetails(list(conceptId), () => loadComments({ conceptId }));
};
